"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { CallDetail } from "@/types/chat";
import { UserType } from "@/types/enums/user-type";
import { MessageSummary } from "@/types/message";
interface UseChatMessagesOptions {
  messages: (MessageSummary | CallDetail)[];
}
interface UseChatMessagesReturn {
  lastMessage: MessageSummary | CallDetail | undefined;
  lastPatientMessage: MessageSummary | CallDetail | undefined;
  displaySuggestion: boolean;
}
export function isCallSummary(message: CallDetail | MessageSummary): message is CallDetail {
  return (message as CallDetail).completedDate !== undefined;
}
export function useChatMessages(t0) {
  const $ = _c(8);
  const {
    messages
  } = t0;
  let t1;
  if ($[0] !== messages) {
    t1 = messages.slice().reverse().find(_temp);
    $[0] = messages;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const lastMessage = t1;
  let t2;
  if ($[2] !== messages) {
    t2 = messages.slice().reverse().find(_temp2);
    $[2] = messages;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const lastPatientMessage = t2;
  let t3;
  bb0: {
    if (!lastMessage && lastPatientMessage && !isCallSummary(lastPatientMessage)) {
      t3 = true;
      break bb0;
    }
    if (lastPatientMessage && !isCallSummary(lastPatientMessage) && lastMessage) {
      const lastPatientIndex = messages.indexOf(lastPatientMessage);
      const lastMessageIndex = messages.indexOf(lastMessage);
      if (lastPatientIndex > lastMessageIndex) {
        t3 = true;
        break bb0;
      }
    }
    t3 = false;
  }
  const displaySuggestion = t3;
  let t4;
  if ($[4] !== displaySuggestion || $[5] !== lastMessage || $[6] !== lastPatientMessage) {
    t4 = {
      lastMessage,
      lastPatientMessage,
      displaySuggestion
    };
    $[4] = displaySuggestion;
    $[5] = lastMessage;
    $[6] = lastPatientMessage;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp2(m_0) {
  return m_0.sender?.type === UserType.PATIENT;
}
function _temp(m) {
  return m.sender?.type !== UserType.PATIENT;
}